import { render, staticRenderFns } from "./rate-modal.vue?vue&type=template&id=6fa568e2&lang=html&"
import script from "./rate-modal.vue?vue&type=script&lang=js&"
export * from "./rate-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports